module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "label-width": "auto",
      "label-position": "left"
    }
  }, [(!_vm.isEditor || (_vm.isEditor && !_vm.form.item_main_cat_id)) ? [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.mainCateLoader),
      expression: "mainCateLoader"
    }],
    attrs: {
      "shadow": "never",
      "header": "选择主分类"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "options": _vm.mainCategory
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.selectedMainCategory),
      callback: function($$v) {
        _vm.selectedMainCategory = $$v
      },
      expression: "selectedMainCategory"
    }
  })], 1)] : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    staticClass: "content-padded view-flex view-flex-middle"
  }, [_c('div', [_vm._v("主分类：")]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "inline",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, _vm._l((_vm.categoryNames), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1), _vm._v(" "), ((!_vm.isEditor && _vm.selectedMainCategory.length > 0) || _vm.isEditor) ? [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("基础信息")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.panelCollapse('base')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.panel.base ? 'icon-window-minimize1' : 'icon-plus'
  })])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel.base),
      expression: "panel.base"
    }],
    staticClass: "form-collapse"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*商品标题"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.item_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_name", $$v)
      },
      expression: "form.item_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 140,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.brief),
      callback: function($$v) {
        _vm.$set(_vm.form, "brief", $$v)
      },
      expression: "form.brief"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*商品通用名(药品)"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入药品的通用名"
    },
    model: {
      value: (_vm.form.common_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "common_name", $$v)
      },
      expression: "form.common_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*及时配送运费模板"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.templates_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "templates_id", $$v)
      },
      expression: "form.templates_id"
    }
  }, _vm._l((_vm.templatesList), function(item) {
    return _c('el-option', {
      key: item.template_id,
      attrs: {
        "label": item.name,
        "value": item.template_id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*快递配送运费模板"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.express_templates_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "express_templates_id", $$v)
      },
      expression: "form.express_templates_id"
    }
  }, _vm._l((_vm.templatesList), function(item) {
    return _c('el-option', {
      key: item.template_id,
      attrs: {
        "label": item.name,
        "value": item.template_id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*品牌"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.brand_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "brand_id", $$v)
      },
      expression: "form.brand_id"
    }
  }, _vm._l((_vm.brandList), function(item) {
    return _c('el-option', {
      key: item.attribute_id,
      attrs: {
        "label": item.attribute_name,
        "value": item.attribute_id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*计量单位"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 60,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.item_unit),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_unit", $$v)
      },
      expression: "form.item_unit"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "排序编号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*商品分类"
    }
  }, [_c('treeselect', {
    attrs: {
      "options": _vm.categoryList,
      "show-count": true,
      "multiple": true,
      "disable-branch-nodes": false,
      "flat": true
    },
    model: {
      value: (_vm.form.item_category),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_category", $$v)
      },
      expression: "form.item_category"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产地"
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "选择地区",
      "options": _vm.regions
    },
    on: {
      "change": _vm.regionChange
    },
    model: {
      value: (_vm.select_regions_value),
      callback: function($$v) {
        _vm.select_regions_value = $$v
      },
      expression: "select_regions_value"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*生产厂家"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 60,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.producer),
      callback: function($$v) {
        _vm.$set(_vm.form, "producer", $$v)
      },
      expression: "form.producer"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*国药准字号"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 60,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.Reg_No_),
      callback: function($$v) {
        _vm.$set(_vm.form, "Reg_No_", $$v)
      },
      expression: "form.Reg_No_"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*商品规格"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 60,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.spec),
      callback: function($$v) {
        _vm.$set(_vm.form, "spec", $$v)
      },
      expression: "form.spec"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*计量单位转换系数"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 10,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.unit_zhuan_huan_value),
      callback: function($$v) {
        _vm.$set(_vm.form, "unit_zhuan_huan_value", $$v)
      },
      expression: "form.unit_zhuan_huan_value"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*商品关键词"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 255,
      "placeholder": "请输入商品关键词（如：商品标题|关键词1|关键词2...）"
    },
    model: {
      value: (_vm.form.keywords),
      callback: function($$v) {
        _vm.$set(_vm.form, "keywords", $$v)
      },
      expression: "form.keywords"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('p', [_vm._v("1. 商品关键词规则：商品标题|关键词1|关键词2|关键词3")]), _vm._v(" "), _c('p', [_vm._v("2. 请务必将商品标题放在关键词首位")]), _vm._v(" "), _c('p', [_vm._v("3. 注意在修改商品标题时，请修改关键词内对应的商品标题")])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否支持医保支付",
      "prop": "is_yibao"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.is_yibao),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_yibao", $$v)
      },
      expression: "form.is_yibao"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*商品图"
    }
  }, [_c('div', [_c('div', {
    staticClass: "pics-box"
  }, [_c('ul', {
    staticClass: "goodspic-wrap"
  }, [_c('draggable', {
    staticClass: "components-view",
    attrs: {
      "options": _vm.dragIssuesOptions
    },
    model: {
      value: (_vm.form.pics),
      callback: function($$v) {
        _vm.$set(_vm.form, "pics", $$v)
      },
      expression: "form.pics"
    }
  }, _vm._l((_vm.form.pics), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "goodspic",
      on: {
        "mouseenter": function($event) {
          return _vm.picsEnter(index)
        },
        "mouseleave": _vm.picsLeave
      }
    }, [_c('el-image', {
      ref: "imageRef",
      refInFor: true,
      attrs: {
        "src": _vm.wximageurl + item,
        "show-progress": "",
        "preview-src-list": _vm.form.pics,
        "fit": "cover"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "goodspic-mask",
      class: (_vm.picsCurrent == index) ? 'on' : ''
    }, [_c('div', {
      staticClass: "iconfont icon-trash-alt",
      on: {
        "click": function($event) {
          return _vm.removePicsImg(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-arrows-alt"
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-eye",
      on: {
        "click": function($event) {
          return _vm.handlePreview(index)
        }
      }
    })])], 1)
  }), 0)], 1), _vm._v(" "), (_vm.form.pics.length < 9) ? _c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handlePicsChange
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('p', [_vm._v("1. 最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：500px * 500px）")]), _vm._v(" "), _c('p', [_vm._v("2. 拖动图片进行可排序")])])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.picsDialog,
      "sc-status": _vm.isGetPics,
      "is-most": _vm.multiple
    },
    on: {
      "chooseImg": _vm.pickPics,
      "closeImgDialog": _vm.closePicsDialog
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上传视频"
    }
  }, [_c('videoPicker', {
    attrs: {
      "data": _vm.itemVideo
    },
    on: {
      "change": _vm.pickVideo
    }
  }), _vm._v(" "), (_vm.itemVideo.media_id) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.deleteVideo
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品属性"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "商品属性"
    },
    model: {
      value: (_vm.form.items_attr),
      callback: function($$v) {
        _vm.$set(_vm.form, "items_attr", $$v)
      },
      expression: "form.items_attr"
    }
  }, _vm._l((_vm.itemsAttrArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "placeholder": "商品属性",
        "label": item,
        "value": index
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品属性范围"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "商品属性范围"
    },
    model: {
      value: (_vm.form.items_scope),
      callback: function($$v) {
        _vm.$set(_vm.form, "items_scope", $$v)
      },
      expression: "form.items_scope"
    }
  }, _vm._l((_vm.itemsScopeArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "placeholder": "商品属性范围",
        "label": item,
        "value": index
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("* 是否特殊商品类型")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.panelCollapse('goods_type')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.panel.goods_type ? 'icon-window-minimize1' : 'icon-plus'
  })])], 1), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.special_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "special_type", $$v)
      },
      expression: "form.special_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "normal"
    }
  }, [_vm._v("普通商品")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "drug"
    }
  }, [_vm._v("处方药")])], 1)], 1), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("商品参数")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.panelCollapse('param')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.panel.param ? 'icon-window-minimize1' : 'icon-plus'
  })])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel.param),
      expression: "panel.param"
    }],
    staticClass: "form-collapse"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.params), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "xs": 24,
        "sm": 12,
        "md": 8,
        "lg": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": item.label
      }
    }, [(item.children.length > 0) ? _c('el-select', {
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.form.item_params[index].attribute_value_id),
        callback: function($$v) {
          _vm.$set(_vm.form.item_params[index], "attribute_value_id", $$v)
        },
        expression: "form.item_params[index].attribute_value_id"
      }
    }, _vm._l((item.children), function(child) {
      return _c('el-option', {
        key: child.value,
        attrs: {
          "label": child.label,
          "value": child.value
        }
      })
    }), 1) : _c('el-input', {
      attrs: {
        "maxlength": 60,
        "placeholder": ""
      },
      model: {
        value: (_vm.form.item_params[index].attribute_value_name),
        callback: function($$v) {
          _vm.$set(_vm.form.item_params[index], "attribute_value_name", $$v)
        },
        expression: "form.item_params[index].attribute_value_name"
      }
    })], 1)], 1)
  }), 1)], 1)])], 1), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "view-flex",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "view-flex-item"
  }, [_vm._v("商品规格")]), _vm._v(" "), (!_vm.isEditor) ? [(_vm.skus.length === 0) ? _c('span', {
    staticClass: "small mark"
  }, [_vm._v("添加多规格商品请先为当前主类目绑定规格!")]) : _vm._e(), _vm._v(" "), (_vm.skus.length > 0) ? [_c('el-switch', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#efefef",
      "active-text": "统一规格",
      "inactive-text": "多规格"
    },
    model: {
      value: (_vm.form.nospec),
      callback: function($$v) {
        _vm.$set(_vm.form, "nospec", $$v)
      },
      expression: "form.nospec"
    }
  })] : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.form.nospec) ? [_c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("是否在商详页成列图片规格")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.form.is_show_specimg),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_show_specimg", $$v)
      },
      expression: "form.is_show_specimg"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), (_vm.form.nospec) ? [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*商品状态",
      "render-header": _vm.renderRequire
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.approve_status),
      callback: function($$v) {
        _vm.$set(_vm.form, "approve_status", $$v)
      },
      expression: "form.approve_status"
    }
  }, _vm._l((_vm.statusOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*库存"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.store),
      callback: function($$v) {
        _vm.$set(_vm.form, "store", $$v)
      },
      expression: "form.store"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*商品货号"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 60,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.item_bn),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_bn", $$v)
      },
      expression: "form.item_bn"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "重量"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.weight),
      callback: function($$v) {
        _vm.$set(_vm.form, "weight", $$v)
      },
      expression: "form.weight"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("g")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "体积"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.volume),
      callback: function($$v) {
        _vm.$set(_vm.form, "volume", $$v)
      },
      expression: "form.volume"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("m³")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*销售价"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    on: {
      "blur": function($event) {
        return _vm.EditPrice(_vm.form.price)
      }
    },
    model: {
      value: (_vm.form.price),
      callback: function($$v) {
        _vm.$set(_vm.form, "price", $$v)
      },
      expression: "form.price"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("¥")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [((_vm.only_show_price_low != '0') || (_vm.only_show_price_high != '0')) ? _c('el-tag', [_vm._v("\n                  ￥" + _vm._s(_vm.only_show_price_low / 100) + " - " + _vm._s(_vm.only_show_price_high / 100) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('el-collapse', [_c('el-collapse-item', {
    attrs: {
      "title": "修改价格不会作用到下列店铺 ",
      "name": "1"
    }
  }, _vm._l((_vm.distributors_prices_arr), function(distritors_prics, key, value) {
    return _c('div', [_vm._v("\n                    店铺id " + _vm._s(key.split('_')[1]) + "  价格:￥" + _vm._s(distritors_prics / 100) + "\n                  ")])
  }), 0)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "成本价"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.cost_price),
      callback: function($$v) {
        _vm.$set(_vm.form, "cost_price", $$v)
      },
      expression: "form.cost_price"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("¥")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*原价"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.market_price),
      callback: function($$v) {
        _vm.$set(_vm.form, "market_price", $$v)
      },
      expression: "form.market_price"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("¥")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "条形码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.barcode),
      callback: function($$v) {
        _vm.$set(_vm.form, "barcode", $$v)
      },
      expression: "form.barcode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "打包费"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.packing_fee),
      callback: function($$v) {
        _vm.$set(_vm.form, "packing_fee", $$v)
      },
      expression: "form.packing_fee"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("¥")])], 2)], 1)], 1)], 1)] : [_vm._l((_vm.skus), function(item, index) {
    return _c('el-card', {
      key: item.index
    }, [_c('div', {
      staticClass: "sku-select__item"
    }, [_c('div', {
      staticClass: "goods"
    }, [_vm._v("\n                " + _vm._s(item.sku_name) + "：\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "sku-select__checkgroup"
    }, [_c('el-checkbox-group', {
      on: {
        "change": _vm.handleSkuChange
      },
      model: {
        value: (item.checked_sku),
        callback: function($$v) {
          _vm.$set(item, "checked_sku", $$v)
        },
        expression: "item.checked_sku"
      }
    }, [_vm._l((item.sku_value), function(value, vn) {
      return [_c('div', {
        staticClass: "sku-select__checkitem"
      }, [(value.image_url) ? _c('imgBox', {
        attrs: {
          "imgUrl": value.image_url,
          "width": "50",
          "height": "50"
        }
      }) : _vm._e(), _vm._v(" "), _c('el-checkbox', {
        attrs: {
          "label": value.attribute_value_id
        }
      }, [(item.checked_sku.indexOf(value.attribute_value_id) !== -1) ? _c('el-input', {
        staticStyle: {
          "width": "100px"
        },
        attrs: {
          "size": "mini"
        },
        on: {
          "change": function($event) {
            return _vm.handleSkuName(value.custom_attribute_value, value.attribute_value_id)
          }
        },
        model: {
          value: (value.custom_attribute_value),
          callback: function($$v) {
            _vm.$set(value, "custom_attribute_value", $$v)
          },
          expression: "value.custom_attribute_value"
        }
      }) : _c('span', [_vm._v(_vm._s(value.attribute_value))])], 1)], 1)]
    })], 2)], 1)])])
  }), _vm._v(" "), (_vm.specImages.length > 0) ? _c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('div', {
    staticClass: "content-padded h3"
  }, [_vm._v("设置规格图片")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.specImages,
      "header-cell-style": {
        background: '#f5f7fa'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "规格",
      "prop": "item_spec",
      "width": "240"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "规格图"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._l((scope.row.item_image_url), function(item, index) {
          return _c('imgBox', {
            key: index,
            attrs: {
              "imgUrl": item,
              "inline": "",
              "removeBtn": "",
              "width": "50",
              "height": "50"
            },
            on: {
              "remove": function($event) {
                return _vm.handleImgRemove(scope.$index, index)
              }
            }
          })
        }), _vm._v(" "), (scope.row.item_image_url.length < 5) ? _c('imgBox', {
          attrs: {
            "width": "50",
            "height": "50",
            "inline": ""
          },
          on: {
            "click": function($event) {
              return _vm.handleSkuImg(scope.$index)
            }
          }
        }) : _vm._e()]
      }
    }], null, false, 2505365326)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-padded h3"
  }, [_vm._v("设置规格")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.bulkFilling,
      "show-header": false,
      "highlight-current-row": false
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.custom_attribute_value || scope.row.item_spec) + "\n              ")]
      }
    }], null, false, 274559478)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "*状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "size": "mini",
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.approve_status),
            callback: function($$v) {
              _vm.$set(scope.row, "approve_status", $$v)
            },
            expression: "scope.row.approve_status"
          }
        }, _vm._l((_vm.statusOption), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.title,
              "size": "mini",
              "value": item.value
            }
          })
        }), 1)]
      }
    }], null, false, 863906553)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.store),
            callback: function($$v) {
              _vm.$set(scope.row, "store", $$v)
            },
            expression: "scope.row.store"
          }
        })]
      }
    }], null, false, 3794582033)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": 60,
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.item_bn),
            callback: function($$v) {
              _vm.$set(scope.row, "item_bn", $$v)
            },
            expression: "scope.row.item_bn"
          }
        })]
      }
    }], null, false, 1632943470)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": 60,
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.weight),
            callback: function($$v) {
              _vm.$set(scope.row, "weight", $$v)
            },
            expression: "scope.row.weight"
          }
        })]
      }
    }], null, false, 1004554920)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": 60,
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.volume),
            callback: function($$v) {
              _vm.$set(scope.row, "volume", $$v)
            },
            expression: "scope.row.volume"
          }
        })]
      }
    }], null, false, 220252480)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "销售价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.price),
            callback: function($$v) {
              _vm.$set(scope.row, "price", $$v)
            },
            expression: "scope.row.price"
          }
        })]
      }
    }], null, false, 3082212771)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "成本价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.cost_price),
            callback: function($$v) {
              _vm.$set(scope.row, "cost_price", $$v)
            },
            expression: "scope.row.cost_price"
          }
        })]
      }
    }], null, false, 1858449783)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "原价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.market_price),
            callback: function($$v) {
              _vm.$set(scope.row, "market_price", $$v)
            },
            expression: "scope.row.market_price"
          }
        })]
      }
    }], null, false, 1576021176)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "条形码"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.barcode),
            callback: function($$v) {
              _vm.$set(scope.row, "barcode", $$v)
            },
            expression: "scope.row.barcode"
          }
        })]
      }
    }], null, false, 170721298)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "打包费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.packing_fee),
            callback: function($$v) {
              _vm.$set(scope.row, "packing_fee", $$v)
            },
            expression: "scope.row.packing_fee"
          }
        })]
      }
    }], null, false, 3294544430)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": _vm.fillSku
          }
        }, [_vm._v("填充")])]
      }
    }], null, false, 4151920980)
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.specItems[_vm.currentPage - 1],
      "header-cell-style": {
        background: '#f5f7fa'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "规格值"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.item_spec), function(item) {
          return _c('span', [_vm._v("\n                  " + _vm._s(item.spec_custom_value_name || item.spec_value_name) + "\n                ")])
        })
      }
    }], null, false, 2317793094)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "render-header": _vm.renderRequire
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "size": "mini",
            "placeholder": "请选择"
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.approve_status),
            callback: function($$v) {
              _vm.$set(scope.row, "approve_status", $$v)
            },
            expression: "scope.row.approve_status"
          }
        }, _vm._l((_vm.statusOption), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.title,
              "size": "mini",
              "value": item.value
            }
          })
        }), 1)]
      }
    }], null, false, 328860283)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存",
      "render-header": _vm.renderRequire
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.store),
            callback: function($$v) {
              _vm.$set(scope.row, "store", $$v)
            },
            expression: "scope.row.store"
          }
        })]
      }
    }], null, false, 1326944115)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": 60,
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.item_bn),
            callback: function($$v) {
              _vm.$set(scope.row, "item_bn", $$v)
            },
            expression: "scope.row.item_bn"
          }
        })]
      }
    }], null, false, 233076972)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量(g)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": 60,
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.weight),
            callback: function($$v) {
              _vm.$set(scope.row, "weight", $$v)
            },
            expression: "scope.row.weight"
          }
        })]
      }
    }], null, false, 2168900074)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积(m³)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": 60,
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.volume),
            callback: function($$v) {
              _vm.$set(scope.row, "volume", $$v)
            },
            expression: "scope.row.volume"
          }
        })]
      }
    }], null, false, 4047312514)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "销售价",
      "render-header": _vm.renderRequire
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.price),
            callback: function($$v) {
              _vm.$set(scope.row, "price", $$v)
            },
            expression: "scope.row.price"
          }
        })]
      }
    }], null, false, 1463242945)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "成本价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.cost_price),
            callback: function($$v) {
              _vm.$set(scope.row, "cost_price", $$v)
            },
            expression: "scope.row.cost_price"
          }
        })]
      }
    }], null, false, 2879515797)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "原价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.market_price),
            callback: function($$v) {
              _vm.$set(scope.row, "market_price", $$v)
            },
            expression: "scope.row.market_price"
          }
        })]
      }
    }], null, false, 1215015674)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "条形码"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.barcode),
            callback: function($$v) {
              _vm.$set(scope.row, "barcode", $$v)
            },
            expression: "scope.row.barcode"
          }
        })]
      }
    }], null, false, 4081517456)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "打包费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.packing_fee),
            callback: function($$v) {
              _vm.$set(scope.row, "packing_fee", $$v)
            },
            expression: "scope.row.packing_fee"
          }
        })]
      }
    }], null, false, 4196558764)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clearSku(scope.$index)
            }
          }
        }, [_vm._v("清除")])]
      }
    }], null, false, 179195380)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.specPagesize,
      "layout": "prev, pager, next",
      "total": _vm.specTotal
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)]], 2), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("服务类商品")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.panelCollapse('goods_type')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.panel.goods_type ? 'icon-window-minimize1' : 'icon-plus'
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "入住商品",
      "prop": "is_settle_in"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.is_settle_in),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_settle_in", $$v)
      },
      expression: "form.is_settle_in"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), (_vm.form.is_settle_in == true) ? _c('el-form-item', {
    attrs: {
      "label": "服务商品",
      "prop": "is_settle_in_service"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.is_settle_in_service),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_settle_in_service", $$v)
      },
      expression: "form.is_settle_in_service"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("否")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.is_settle_in_service == true && _vm.form.is_settle_in == true) ? _c('el-form-item', {
    attrs: {
      "label": "服务费",
      "prop": "si_charging_method"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.si_charging_method),
      callback: function($$v) {
        _vm.$set(_vm.form, "si_charging_method", $$v)
      },
      expression: "form.si_charging_method"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "rate"
    }
  }, [_vm._v("费率")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "fixed_costs"
    }
  }, [_vm._v("固定费用")])], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.form.si_charging_method == 'rate' && _vm.form.is_settle_in_service == true && _vm.form.is_settle_in == true) ? _c('el-form-item', {
    attrs: {
      "label": "费率（百分比）",
      "prop": "si_rate"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "百分比",
      "maxlength": "4",
      "minlength": "4"
    },
    model: {
      value: (_vm.form.si_rate),
      callback: function($$v) {
        _vm.$set(_vm.form, "si_rate", $$v)
      },
      expression: "form.si_rate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.si_charging_method == 'fixed_costs' && _vm.form.is_settle_in_service == true && _vm.form.is_settle_in == true) ? _c('el-form-item', {
    attrs: {
      "label": "固定费用（元）",
      "prop": "si_fixed_costs"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "元",
      "maxlength": "4",
      "minlength": "4"
    },
    model: {
      value: (_vm.form.si_fixed_costs),
      callback: function($$v) {
        _vm.$set(_vm.form, "si_fixed_costs", $$v)
      },
      expression: "form.si_fixed_costs"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品库存是否从NP取",
      "prop": "is_NP_store"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.is_NP_store),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_NP_store", $$v)
      },
      expression: "form.is_NP_store"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("中药产品")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.panelCollapse('param')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.panel.param ? 'icon-window-minimize1' : 'icon-plus'
  })])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel.param),
      expression: "panel.param"
    }],
    staticClass: "form-collapse"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否报销",
      "prop": "is_apply"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.is_apply),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_apply", $$v)
      },
      expression: "form.is_apply"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "header": "图文详情",
      "shadow": "never"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模式"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.mode),
      callback: function($$v) {
        _vm.mode = $$v
      },
      expression: "mode"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'richText'
    }
  }, [_vm._v("富文本")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'component'
    }
  }, [_vm._v("组件式")])], 1)], 1), _vm._v(" "), (_vm.mode === 'richText') ? [_c('vue-html5-editor', {
    ref: "editor",
    attrs: {
      "content": _vm.form.intro,
      "height": 360
    },
    on: {
      "change": _vm.updateContent
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tpl_item img",
    on: {
      "click": _vm.addImgPreview
    }
  }, [_c('i', {
    staticClass: "iconfont icon-image"
  }), _vm._v("图片\n        ")])] : [_c('richTextEditor', {
    attrs: {
      "data": _vm.content,
      "control": ['film', 'slider', 'heading', 'writing']
    },
    on: {
      "change": _vm.handleContent
    }
  })], _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.thumbDialog,
      "sc-status": _vm.isGetThumb,
      "isMost": true
    },
    on: {
      "chooseImg": _vm.pickThumb,
      "closeImgDialog": _vm.closeThumbDialog
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submitItemsActionConfirm
    }
  }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' : '保存'))])], 1)] : _vm._e()], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-aa552e0c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa552e0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/physical/add.vue
// module id = 2908
// module chunks = 0